export const DAYS_OF_WEEK_MAP: Map<string, string> = new Map([
  ['Monday', 'mon'],
  ['Tuesday', 'tue'],
  ['Wednesday', 'wed'],
  ['Thursday', 'thu'],
  ['Friday', 'fri'],
  ['Saturday', 'sat'],
  ['Sunday', 'sun']
]);
